// TODO: don't show manage subscription if no subscription
// TODO: P1: update remaining credits when you open the page
import { Link } from 'react-router-dom';
// import Intercom from '@intercom/messenger-js-sdk';
// import { boot, update } from "@intercom/messenger-js-sdk";

import React, { useEffect, useState, useRef } from 'react';
import userStore from '../../../Stores/User';
import { useHistory } from 'react-router-dom';
import isUrl from 'is-url';
import { ReactComponent as Plus } from '../Icons/Plus.svg';
import { observer } from 'mobx-react';
import { mergeStyleSets, Modal } from '@fluentui/react';
import loadingIcon from '../../../Assets/loading.gif';
import { dryrunArticle, addArticleToUserPlaylist, updateUserTldrPreference, getUser, addUserFeed, getUserFeeds, getUserPlaylist, createReactivationCheckoutSession } from '../../../audiblogsApi';
import { createStripeSessionAndRedirectToCheckout } from '../../../stripeLogic';
import '../index.scss';
import Chrome from '../../../Assets/chrome.svg';
import Edge from '../../../Assets/edge.svg';
import AppleStore from '../../../Assets/apple-app-store.svg';
import GoogleStore from '../../../Assets/google-play-store.svg';
import mixpanel from 'mixpanel-browser';
import { isMobile } from 'react-device-detect';
import PaidIcon from '@mui/icons-material/Paid';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import gamificationStore from '../../../Stores/GamificationStore';
import BonusIndicator from '../../../Components/BonusIndicator';
// import Intercom from '@intercom/messenger-js-sdk';
// import AppleIcon from "@material-ui/icons/Apple";
// import AndroidIcon from "@material-ui/icons/Android";
// import RssFeedIcon from "@material-ui/icons/RssFeed";
import {
  Apple as AppleIcon,
  Android as AndroidIcon,
  RssFeed as RssFeedIcon,
  Link as LinkIcon,
  Upload as UploadIcon,
  TextFields as TextIcon,
  Search as SearchIcon,
  Email as EmailIcon,
} from '@mui/icons-material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Upload from './Upload';
import isSupportedType from '../isSupportedType';
import { useBoolean } from '@fluentui/react-hooks';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Checkout from '../../Checkout';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import { Switch, Tooltip } from '@mui/material';
import { isPaidProUser, hasPaidPlan } from '../../../constants/plans';
import HelpIcon from '@mui/icons-material/Help';
import PlaylistArticles from './PlaylistArticles';
import ArticleLoader from './ArticleLoader';
import store from '../store';
import FeedsModal from './FeedsModal';

const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column',
    backgroundColor: 'rgba(15, 15, 25, 0.98)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    width: '400px',
    padding: '24px',
    fontFamily: 'Cabin, sans-serif',
    fontSize: '16px',
    textAlign: 'left',
    minHeight: '120px',
    borderRadius: '16px',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
  },
});

const AddArticle = observer(
  ({
    triggers,
    trackingId,
    selectionText,
    updateAddUrl: setArticleUrl,
    addUrl: articleUrl,
    addApp: app,
    addForce,
  }) => {
    const [shouldForceAdd, setShouldForceAdd] = useState(addForce);
    const [status, setStatus] = useState('');
    const [buttonMessage, setButtonMessage] = useState('Add Article');
    const [estimate, setEstimate] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showEmail, setShowEmail] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [redirectTo, setRedirectTo] = useState('');
    const [isMounted, setIsMounted] = useState(true);
    const [showLinkModal, setShowLinkModal] = useState(false);
    const [linkInputValue, setLinkInputValue] = useState('');
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showFeedsModal, setShowFeedsModal] = useState(false);
    const linkInputRef = useRef(null);
    const {
      user,
      idToken,
      isSignedIn,
      userFeedUrl,
      creditsHd,
      creditsSd,
    } = userStore;
    const [lowCreditTrigger, setLowCreditTrigger] = useState();
    const [
      isModalOpen,
      { setTrue: showModal, setFalse: hideModal },
    ] = useBoolean(false);
    const history = useHistory();
    const [addTldr, setAddTldr] = useState(false);
    const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
      ? isPaidProUser(userStore.user)
      : false;
    const isPaidUser = hasPaidPlan(userStore.user)
    const [monthlyConversions, setMonthlyConversions] = useState(0);

    useEffect(() => {
      if (user && articleUrl && user.user_id !== undefined) {
        if (isSupportedType(articleUrl, user.user_id)) showModal();
      }
    }, [articleUrl, user]);

    useEffect(() => {
      triggers.forEach((trigger) => {
        if (trigger.name === 'low_on_credits') {
          setLowCreditTrigger(true);
        }
      });
    }, [triggers]);

    useEffect(() => {
      // Fetch user data to get the current TLDR preference
      getUser(idToken)
        .then(response => {
          if (response.data) {
            setAddTldr(response.data.addTldr); // Set the toggle based on user data
          }
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
        });
    }, [idToken]);

    useEffect(() => {
          // Add a style element to remove underlines from all links in this component and fix mobile layout
    const style = document.createElement('style');
    style.textContent = `
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      .add-article-container a, 
      .add-article-container a span, 
      .add-article-container .link,
      .add-article-container .link span {
        text-decoration: none !important;
      }
      
      .add-article-container .article-container {
        display: flex !important;
        flex-direction: column !important;
        flex-wrap: nowrap !important;
        gap: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      
      .add-article-container .playlist-article-card {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      .add-article-container .playlist-article-card .article {
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 16px 16px !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
      }
      
      .add-article-container .playlist-article-card .article .meta {
        display: flex !important;
        gap: 8px !important;
        flex: 1 !important;
        min-width: 0 !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .play-button {
        min-width: 32px !important;
        height: 32px !important;
        border-radius: 16px !important;
        margin: 0 !important;
        flex-shrink: 0 !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .play-button img {
        width: 14px !important;
        height: 14px !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .content {
        flex: 1 !important;
        min-width: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 4px !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .content .title {
        margin: 0 !important;
        gap: 6px !important;
        font-size: 14px !important;
        line-height: 1.3 !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .content .subtitle {
        gap: 6px !important;
        font-size: 12px !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .content .subtitle .time {
        gap: 6px !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .content .subtitle .time .action-icons {
        gap: 6px !important;
        margin-left: 6px !important;
      }
      
      .add-article-container .playlist-article-card .article .meta .content .subtitle .time .action-icons .action-icon {
        font-size: 14px !important;
      }
      
              @media (max-width: 768px) {
          .add-article-container .playlist-article-card .article {
            padding: 14px 12px !important;
            gap: 6px !important;
          }
        
        .add-article-container .playlist-article-card .article .meta {
          gap: 6px !important;
        }
        
        .add-article-container .playlist-article-card .article .meta .play-button {
          min-width: 28px !important;
          height: 28px !important;
          border-radius: 14px !important;
        }
        
        .add-article-container .playlist-article-card .article .meta .play-button img {
          width: 12px !important;
          height: 12px !important;
        }
        
        .add-article-container .playlist-article-card .article .meta .content .title {
          font-size: 13px !important;
          gap: 4px !important;
        }
        
        .add-article-container .playlist-article-card .article .meta .content .subtitle {
          font-size: 11px !important;
          gap: 4px !important;
        }
        
        .add-article-container .playlist-article-card .article .meta .content .subtitle .time {
          gap: 4px !important;
        }
        
        .add-article-container .playlist-article-card .article .meta .content .subtitle .time .action-icons {
          gap: 4px !important;
          margin-left: 4px !important;
        }
        
        .add-article-container .playlist-article-card .article .meta .content .subtitle .time .action-icons .action-icon {
          font-size: 12px !important;
        }
        
        /* Mobile bonus indicator fixes */
        .add-article-container .bonus-indicator {
          position: relative !important;
          overflow: visible !important;
          width: 100% !important;
        }
        
        .add-article-container .bonus-indicator .bonus-badge {
          position: absolute !important;
          top: -6px !important;
          right: 6px !important;
          z-index: 10 !important;
          max-width: 100px !important;
          overflow: visible !important;
          pointer-events: none !important;
        }
        
        .add-article-container .bonus-indicator .bonus-text {
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          max-width: 50px !important;
        }
        
        .add-article-container .bonus-indicator .bonus-icon {
          font-size: 14px !important;
        }
      }
    `;
    document.head.appendChild(style);
    
    // Clean up the style element when component unmounts
    return () => {
      document.head.removeChild(style);
    };
    }, []);

    // Add cleanup on unmount
    useEffect(() => {
      return () => {
        setIsMounted(false);
      };
    }, []);

    const sendDryrunRequest = () => {
      // setIsLoading(true);
      axios
        .post(process.env.REACT_APP_BACKEND_URL + '/api/upload', {
          article_url: articleUrl,
        })
        .then((res) => {
          console.log(res);
          setIsLoading(false);
          if (res.data.A && res.data.B) {
            console.log('redirecting...');
            // Parset the file name from the url
            const fileName = articleUrl.split('/').pop();
            setRedirectTo(
              `/add/text?type=pdf&title=${fileName}&text=${encodeURIComponent(
                res.data.A
              )}&backupText=${encodeURIComponent(res.data.B)}`
            );
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });

      dryrunArticle(articleUrl, selectionText, idToken)
        .then((res) => {
          if (res.data.is_supported) {
            // if (res.data.estimated_credit_cost < 0.01) {
            //   setEstimate('0');
            // } else {
            //   setEstimate(res.data.estimated_credit_cost);
            // }
          } else {
            setStatus(res.data.reason);
            setButtonMessage('Request Support');
            setEstimate('0');
          }
        })
        .catch((e) => {
          setEstimate('Unavailable');
          setStatus('Something went wrong.');
          console.log(e);
        });
    };

    const redirectOrDryrunOrSend = () => {
      if (isUrl(articleUrl)) {
        if (isSignedIn === false) {
          // TODO: need to add user_id
          // TODO: need to add article url, etc so it starts an onboarding process ixf necessary.
          // TODO: Add redirection
          const params = `?redirected_from=add&url=${encodeURIComponent(
            articleUrl
          )}`;
          history.push(
            trackingId ? `/signin/${trackingId}${params}` : `/signin${params}`
          );
        } else if (isSignedIn === true) {
          // Auto-submit if shouldForceAdd is true OR if there's a URL from Chrome extension
          if (shouldForceAdd || (articleUrl && window.location.search.includes('url='))) {
            sendArticle();
            setShouldForceAdd(false);
          }
        }
      }
    };

  useEffect(() => {
    console.log('paid user', isPaidUser);
    console.log('pro user', isProUser);
    
    // Extract URL from search params if present
    const urlParams = new URLSearchParams(window.location.search);
    let sharedUrl = urlParams.get('url'); // Standard URL parameter
    
    // Handle Android Web Share Target API parameters
    if (!sharedUrl && urlParams.get('app') === 'android') {
      // Try to get URL from Android share parameters
      sharedUrl = urlParams.get('text') || urlParams.get('url_description');
      
      // If text contains a URL, extract it
      if (sharedUrl) {
        const urlMatch = sharedUrl.match(/https?:\/\/[^\s]+/);
        if (urlMatch) {
          sharedUrl = urlMatch[0];
        }
      }
    }
    
    // If we have a shared URL and no articleUrl is set yet, set it
    if (sharedUrl && !articleUrl) {
      setArticleUrl(sharedUrl);
      setShouldForceAdd(true); // Force auto-submit for shared URLs
    }

    redirectOrDryrunOrSend();

    if (
      !isUrl(articleUrl) &&
      articleUrl.length >= 20 &&
      !articleUrl.startsWith('file://') &&
      !articleUrl.startsWith('http') &&
      !articleUrl.endsWith('.rss')
    ) {
        // NOTE: if a user types text in the article URL section
        // or a body of text gets shared on iOS
        // Get the current date
        setRedirectTo(
          `/add/text?type=input_text&title=untitled&text=${encodeURIComponent(articleUrl)}`
        );
      } else if (
        !isUrl(articleUrl) &&
        articleUrl.length > 10 &&
        !articleUrl.startsWith('http') &&
        !articleUrl.endsWith('.rss')
      ) {
        setStatus('Please enter a valid URL');
      } else if (articleUrl.length === 0) {
        setStatus('');
      }
    }, [isSignedIn, articleUrl]);

    useEffect(() => {
      if (articleUrl && isUrl(articleUrl)) {
      }
    }, [articleUrl]);

    useEffect(() => {
      // Hide Intercom
      // update({
      //   hide_default_launcher: true
      // });

      mixpanel.track('Open Add Article');
      const tolt_referral = window.tolt_referral

      // Set Once
      mixpanel.people.set_once({
        utm_source: mixpanel.get_property('utm_source'),
        utm_medium: mixpanel.get_property('utm_medium'),
        utm_campaign: mixpanel.get_property('utm_campaign'),
        utm_term: mixpanel.get_property('utm_term'),
        search_engine: mixpanel.get_property('$search_engine'),
        search_keyword: mixpanel.get_property('mp_keyword'),
        referrer: mixpanel.get_property('$referrer'),
        initial_referrer: mixpanel.get_property('$initial_referrer'),
        tolt_referral: tolt_referral,

      });

      if (shouldForceAdd) {
        setIsLoading(true);
      }
    }, []);

    const normalizeUrl = (url) => {
      if (!url) return url;
      url = url.trim();
      if (!/^https?:\/\//i.test(url)) {
        return `https://${url}`;
      }
      return url;
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      
      // First check if this is text content that should redirect
      if (
        !isUrl(articleUrl) &&
        articleUrl.length >= 20 &&
        !articleUrl.startsWith('file://') &&
        !articleUrl.startsWith('http') &&
        !articleUrl.endsWith('.rss')
      ) {
        // This is likely text content, not a URL - redirect to text page
        setRedirectTo(
          `/add/text?type=input_text&title=untitled&text=${encodeURIComponent(articleUrl)}`
        );
        return;
      }
      
      // Only normalize as URL if we've determined it's not text content
      const normalizedUrl = normalizeUrl(articleUrl);
      setArticleUrl(normalizedUrl);
      
      // Use the normalized URL directly instead of relying on state update
      if (isUrl(normalizedUrl)) {
        if (isSignedIn === false) {
          const params = `?redirected_from=add&url=${encodeURIComponent(normalizedUrl)}`;
          history.push(
            trackingId ? `/signin/${trackingId}${params}` : `/signin${params}`
          );
        } else if (isSignedIn === true) {
          sendArticle(null, normalizedUrl);
          if (shouldForceAdd) {
            setShouldForceAdd(false);
          }
        }
      }
    };

    const handleAddArticle = () => {
      if (isUrl(articleUrl)) {
        if (isSignedIn === false) {
          // TODO: need to add user_id
          // TODO: need to add article url, etc so it starts an onboarding process ixf necessary.
          // TODO: Add redirection
          const params = `?redirected_from=add&url=${encodeURIComponent(
            articleUrl
          )}`;
          history.push(
            trackingId ? `/signin/${trackingId}${params}` : `/signin${params}`
          );
        } else if (isSignedIn === true) {
          // sendDryrunRequest();
          sendArticle();
          if (shouldForceAdd) {
            setShouldForceAdd(false);
          }
        }
      }
    };

    // Add this function to check if URL is likely an RSS feed
    const isRssFeedUrl = (url) => {
      return url && (
        url.includes('.xml') || 
        url.includes('rss') || 
        url.includes('/feed') ||
        url.includes('atom')
      );
    };
    
    // Update button text based on URL type
    useEffect(() => {
      if (articleUrl) {
        if (isRssFeedUrl(articleUrl)) {
          setButtonMessage('Add Feed');
        } else {
          setButtonMessage('Add Article');
        }
      } else {
        setButtonMessage('Add Article');
      }
    }, [articleUrl]);

    // Add this function to check monthly conversions
    const checkMonthlyConversions = async () => {
      try {
        const response = await getUserPlaylist(idToken);
        const articles = response || [];
        
        // Get date 30 days ago
        const now = new Date();
        const thirtyDaysAgo = new Date(now.getTime() - (30 * 24 * 60 * 60 * 1000));
        
        console.log('Checking monthly conversions:', {
          totalArticles: articles.length,
          thirtyDaysAgo: thirtyDaysAgo.toISOString(),
          now: now.toISOString()
        });
        
        // Count non-feed articles from last 30 days
        const monthlyConversions = articles.filter(article => {
          const articleDate = new Date(article.date_added);
          const isRecent = articleDate >= thirtyDaysAgo;
          const isNotFeed = !article.feed_id;
          const isNotKeyFeatures = article.article_id !== 'audioread.com/key-features-and-how-tos';
          
          console.log('Article check:', {
            articleId: article.article_id,
            dateAdded: article.date_added,
            articleDate: articleDate.toISOString(),
            isRecent,
            isNotFeed,
            isNotKeyFeatures,
            feedId: article.feed_id
          });
          
          return isNotFeed && isRecent && isNotKeyFeatures;
        }).length;
        
        console.log('Monthly conversions result:', {
          monthlyConversions,
          isPaidUser,
          isProUser
        });
        
        return monthlyConversions;
      } catch (error) {
        console.error('Error checking monthly conversions:', error);
        return 0;
      }
    };

    const sendArticle = async (e, urlToProcess = null) => {
      if (e) {
        e.preventDefault();
      }
      
      const url = urlToProcess || articleUrl;
      
      // Check if URL is a YouTube URL
      const isYoutubeUrl = url.match(/(?:youtube\.com|youtu\.be)/i);
      if (isYoutubeUrl) {
        setModalContent({
          title: "YouTube Not Supported",
          message: "Sorry, we no longer support YouTube video conversions.",
        });
        showModal();
        setIsLoading(false);
        return;
      }
      
      if (isMounted) {
        setIsLoading(true);
      }
      
      console.log('Sending article:', url);
      
      const isRssFeed = isRssFeedUrl(url);
      
      if (isRssFeed) {
        // Check if user is on pro plan
        if (!isProUser) {
          setModalContent({
            title: "Pro Feature",
            message: "Upgrade to pro to add feeds by URLs.",
            actionText: "Upgrade Now",
            actionHandler: () => {
              // Check if user has a customer_id but no active subscription (cancelled)
              const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
              const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
              
              if (hasStripeCustomerId && !hasActiveSubscription) {
                // User has cancelled subscription - create reactivation checkout
                createReactivationCheckoutSession(userStore.idToken, {}, '/add')
                  .then(response => {
                    if (response.data.url) {
                      window.location.href = response.data.url;
                    } else {
                      window.location.href = '/onboarding/choosevoice';
                    }
                  })
                  .catch(() => {
                    window.location.href = '/onboarding/choosevoice';
                  });
              } else {
                // User has active subscription - send to customer portal
                window.location.href = userStore.customerPortalUrl;
              }
              hideModal();
            }
          });
          showModal();
          setIsLoading(false);
          return;
        }

        // Handle as RSS feed
        mixpanel.track('Add RSS Feed', { feed_url: url });
        console.log('Adding RSS feed:', url);
        
        // First check if user is already subscribed to this feed
        getUserFeeds(idToken)
          .then((response) => {
            const userFeeds = response.data.feeds || [];
            const isAlreadySubscribed = userFeeds.some(feed => 
              feed.feed_url === url || 
              feed.feed_url.replace(/\/+$/, '') === url.replace(/\/+$/, '') // Compare without trailing slashes
            );
            
            if (isAlreadySubscribed) {
              // User is already subscribed to this feed
              setModalContent({
                title: "Already Subscribed",
                message: "You are already subscribed to this feed.",
              });
              showModal();
              setIsLoading(false);
              return;
            }
            
            // User is not subscribed, proceed with adding the feed
            return addUserFeed(idToken, url)
              .then((res) => {
                console.log('Feed added:', res);
                if (isMounted) {
                  setArticleUrl('');
                  setButtonMessage('Feed Added!');
                  
                  // Award bonus characters for subscribing to feed
                  gamificationStore.completeAction(gamificationStore.actions.SUBSCRIBE_FEED);
                  
                  // Show success message
                  setModalContent({
                    title: "Feed Added",
                    message: "Your feed has been added successfully. You'll start receiving new articles from this feed automatically within the next few hours.",
                  });
                  showModal();
                  
                  setTimeout(() => {
                    setButtonMessage('Add Article');
                  }, 3000);
                }
              });
          })
          .catch((err) => {
            console.error('Error adding feed:', err);
            
            // Show error message
            setModalContent({
              title: "Error Adding Feed",
              message: err.response?.data?.message || "There was a problem adding your feed. Please check the URL and try again.",
            });
            showModal();
          })
          .finally(() => {
            if (isMounted) {
              setIsLoading(false);
            }
          });
      } else {
        // Handle as regular article
        mixpanel.track('Add Article at /add', { article_url: url });
        
        // Check monthly character limit for all users, and conversion count for unpaid users
        const conversions = await checkMonthlyConversions();
        
        // Only check conversion count limit for unpaid users
        if (!isPaidUser && conversions >= 3) {
          setModalContent({
            title: "Limit Reached",
            message: `You've reached your limit of 3 article conversions in the last 30 days. Upgrade to a paid plan for unlimited article conversions per month.`,
            actionText: "Upgrade Now",
            actionHandler: () => {
              // Check if user has a customer_id but no active subscription (cancelled)
              const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
              const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
              
              if (hasStripeCustomerId && !hasActiveSubscription) {
                // User has cancelled subscription - create reactivation checkout
                createReactivationCheckoutSession(userStore.idToken, {}, '/add')
                  .then(response => {
                    if (response.data.url) {
                      window.location.href = response.data.url;
                    } else {
                      window.location.href = '/onboarding/choosevoice';
                    }
                  })
                  .catch(() => {
                    window.location.href = '/onboarding/choosevoice';
                  });
              } else {
                // User has active subscription - send to customer portal
                window.location.href = userStore.customerPortalUrl;
              }
              hideModal();
            }
          });
          showModal();
          setIsLoading(false);
          return;
        }
        
        // Proceed with article conversion
        proceedWithArticleConversion(url);
      }
    };

        const proceedWithArticleConversion = (articleUrlToProcess) => {
      // Create a temporary article object to show in the playlist immediately
      const tempArticle = {
        article_id: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        title: articleUrlToProcess.length > 50 ? articleUrlToProcess.substring(0, 50) + '...' : articleUrlToProcess,
        article_url: articleUrlToProcess,
        status: 'in_progress',
        status_details: 'Starting conversion...',
        date_added: new Date().toISOString(),
        played: false,
        deleted: false,
        audio_url: 'https://audioread.com/share/placeholder.mp3',
        thumbnail_url: null,
        voice_name: null,
        language: null,
        num_characters: 0,
        feed_id: null,
        isLoader: true // Mark as loader to show ArticleLoader component
      };

      // Add the temporary article to the playlist immediately
      store.addTemporaryArticle(tempArticle);

      // Clear the input field immediately
      setArticleUrl('');
      setIsLoading(false);

      // Start polling for updates
      let pollCount = 0;
      const maxPolls = 60; // Poll for up to 5 minutes (60 * 5 seconds)
      
      const pollForUpdates = () => {
        if (pollCount >= maxPolls) {
          // Stop polling after max attempts
          return;
        }

        getUserPlaylist(idToken)
          .then((playlist) => {
            if (playlist && Array.isArray(playlist)) {
              // Find the actual article that was added
              const actualArticle = playlist.find(article => 
                article.article_url === articleUrlToProcess && 
                article.date_added > new Date(Date.now() - 60000) // Added in the last minute
              );

              if (actualArticle) {
                // Replace the temporary article with the real one
                store.replaceTemporaryArticle(tempArticle.article_id, actualArticle);

                // If the article is still processing, continue polling
                if (actualArticle.status === 'in_progress' || actualArticle.status === 'pending') {
                  pollCount++;
                  setTimeout(pollForUpdates, 5000); // Poll every 5 seconds
                } else {
                  // Article is complete or failed, stop polling
                  console.log('Article processing complete:', actualArticle.status);
                  // Update the status details to show completion
                  if (actualArticle.status === 'completed') {
                    store.replaceTemporaryArticle(tempArticle.article_id, {
                      ...actualArticle,
                      status_details: 'Processing complete!'
                    });
                  }
                }
              } else {
                // Article not found yet, continue polling
                pollCount++;
                setTimeout(pollForUpdates, 5000);
              }
            }
          })
          .catch((error) => {
            console.error('Error polling for article updates:', error);
            pollCount++;
            setTimeout(pollForUpdates, 5000);
          });
      };

      // Start polling after a short delay
      setTimeout(pollForUpdates, 2000);

      // Make the actual API call to add the article
      addArticleToUserPlaylist(
        {
          title: '',
          article_url: articleUrlToProcess, 
          type: '',
          text: '',
          tldr: addTldr,
        },
        idToken,
        '/add',
      )
        .then((res) => {
          console.log('Article added successfully:', res);
          // The polling will handle updating the playlist with the real article
          
          // Award bonus characters for adding first article
          gamificationStore.completeAction(gamificationStore.actions.ADD_ARTICLE);
        })
        .catch((err) => {
          console.log('Error adding article:', err);
          
          // Remove the temporary article if there was an error
          store.removeTemporaryArticle(tempArticle.article_id);

          // Handle character limit error (429) - redirect to character purchase
          if (err.response?.status === 429) {
            // Redirect to character purchase page or show inline error
            console.error('Character limit reached:', err.response.data);
            // For now, just log the error and let the user see the loader disappear
          } else {
            // Log other errors
            console.error('Error adding article:', err);
          }
        });
    };

    const handleTldrClick = () => {
      if (isProUser) {
        setAddTldr(!addTldr);
        updateUserTldrPreference(user.user_id, !addTldr)
          .then(response => {
            console.log('User record updated:', response.data);
          })
          .catch(error => {
            console.error('Error updating user record:', error);
          });
      } else {
        // Show modal for non-pro users
        setModalContent({
          title: "Pro Feature", 
          message: "Upgrade to pro to use the summary feature.",
          actionText: "Upgrade Now",
          actionHandler: () => {
            // Check if user has a customer_id but no active subscription (cancelled)
            const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
            const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
            console.log('hasStripeCustomerId', hasStripeCustomerId);
            console.log('hasActiveSubscription', hasActiveSubscription);
            
            if (hasStripeCustomerId && !hasActiveSubscription) {
              // User has cancelled subscription - create reactivation checkout
              createReactivationCheckoutSession(userStore.idToken, {}, '/add')
                .then(response => {
                  if (response.data.url) {
                    window.location.href = response.data.url;
                  } else {
                    window.location.href = '/onboarding/choosevoice';
                  }
                })
                .catch(() => {
                  window.location.href = '/onboarding/choosevoice';
                });
            } else {
              // User has active subscription - send to customer portal
              window.location.href = userStore.customerPortalUrl;
            }
            hideModal();
          }
        });
        showModal();
      }
    };

    const handleLinkModalSubmit = (e) => {
      e.preventDefault();
      const normalizedUrl = normalizeUrl(linkInputValue);
      setArticleUrl(normalizedUrl);
      setShowLinkModal(false);
      setLinkInputValue('');
      
      // Use the normalized URL directly instead of relying on state update
      if (isUrl(normalizedUrl)) {
        if (isSignedIn === false) {
          const params = `?redirected_from=add&url=${encodeURIComponent(normalizedUrl)}`;
          history.push(
            trackingId ? `/signin/${trackingId}${params}` : `/signin${params}`
          );
        } else if (isSignedIn === true) {
          // Pass the normalized URL directly to sendArticle
          sendArticle(null, normalizedUrl);
        }
      }
    };

    const handleLinkButtonClick = () => {
      setLinkInputValue('');
      setShowLinkModal(true);
    };

    // Focus the link input when modal opens
    useEffect(() => {
      if (showLinkModal) {
        // Try multiple times with different delays to ensure focus works
        const focusAttempts = [100, 300, 500, 1000];
        focusAttempts.forEach(delay => {
          setTimeout(() => {
            if (linkInputRef.current) {
              linkInputRef.current.focus();
              console.log(`Link input focused after ${delay}ms`);
            } else {
              console.log(`Link input ref not found after ${delay}ms`);
            }
          }, delay);
        });
      }
    }, [showLinkModal]);

    const handleRssButtonClick = () => {
      setShowFeedsModal(true);
    };

    const handleEmailButtonClick = () => {
      if (!user || !user.user_id) {
        setModalContent({
          title: "Sign In Required",
          message: "Please sign in to get your custom email address.",
        });
        showModal();
        return;
      }

      const emailAddress = `user-${user.user_id}@email.audioread.com`;
      
      // Copy to clipboard
      navigator.clipboard.writeText(emailAddress).then(() => {
        // Show success message
        setModalContent({
          title: "Email Copied!",
          message: `Your custom email address has been copied to your clipboard. Send any email to ${emailAddress} and it will be instantly added to your Audioread playlist.`,
        });
        showModal();
      }).catch((err) => {
        console.error('Failed to copy email:', err);
        // Fallback: show the email in a modal
        setModalContent({
          title: "Your Custom Email",
          message: `Send any email to ${emailAddress} and it will be instantly added to your Audioread playlist.`,
        });
        showModal();
      });
    };

    const handleMobileMenuToggle = () => {
      setShowMobileMenu(!showMobileMenu);
    };

    // Add a new function to handle text input changes
    const handleInputChange = (e) => {
      try {
        const value = e.target.value;
        
        // Always update the input value first
        setArticleUrl(value);
        
        // Only redirect for longer text content after a small delay
        if (value.length >= 50 && 
            !isUrl(value) && 
            !value.startsWith('http') && 
            !value.startsWith('file://')) {
          
          // Use setTimeout to avoid immediate state updates
          const timeoutId = setTimeout(() => {
            try {
              if (isMounted) {
                window.location.href = `/add/text?type=input_text&title=untitled&text=${encodeURIComponent(value)}`;
              }
            } catch (err) {
              console.error('Error redirecting to text page:', err);
              // Fallback - clear input and show error
              if (isMounted) {
                setArticleUrl('');
                setStatus('Error processing text input. Please try again.');
              }
            }
          }, 100);

          // Cleanup timeout on unmount
          return () => clearTimeout(timeoutId);
        }
      } catch (err) {
        console.error('Error in handleInputChange:', err);
        if (isMounted) {
          setArticleUrl('');
          setStatus('Error processing input. Please try again.');
        }
      }
    };

    if (redirectTo) {
      window.location.href = redirectTo;
      return null;
    }

    // useEffect(() => {
    //   Intercom({
    //     app_id: "fduylg2r", 
    //     hide_default_launcher: false,
    //     mobile: true,
    //   });
    // }, []);

    // Load playlist articles when component mounts
    useEffect(() => {
      if (isSignedIn && store.playlistArticles === null) {
        store.loadPlaylist();
      }
    }, [isSignedIn]);

    // Track basic plan conversion
    useEffect(() => {
      const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
      const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
      console.log('hasStripeCustomerId', hasStripeCustomerId);
      console.log('hasActiveSubscription', hasActiveSubscription);
      const subscription = userStore.user?.subscriptions?.raw_subscriptions?.[0];
      if (subscription) {
        if (isProUser) {
          console.log('Tracking pro plan conversion');
          // Google Analytics tracking
          window.gtag('event', 'conversion', {
            'send_to': 'AW-16989360809/y69hCO-NzLYaEKmllKU_',
            'value': 100.0,
            'currency': 'USD',
            'transaction_id': subscription.id || '',
          });
          // Microsoft Ads tracking
          if (window.uetq) {
            window.uetq.push('event', 'subscribe', {
              value: 100.0,
              currency: 'USD',
              transaction_id: subscription.id || '',
            });
          }
          // Mixpanel tracking for verification
          mixpanel.track('Google Conversion', {
            user_email: userStore.user?.email,
            subscription_id: subscription.id,
            plan: 'pro',
            value: 100.0,
            currency: 'USD',
            google_conversion_id: 'AW-16989360809/y69hCO-NzLYaEKmllKU_'
          });
        } else {
          console.log('Tracking basic plan conversion');
          // Google Analytics tracking
          window.gtag('event', 'conversion', {
            'send_to': 'AW-16989360809/dsGWCOyNzLYaEKmllKU_',
            'value': 30.0,
            'currency': 'USD',
            'transaction_id': subscription.id || '',
          });
          // Microsoft Ads tracking
          if (window.uetq) {
            window.uetq.push('event', 'subscribe', {
              value: 30.0,
              currency: 'USD',
              transaction_id: subscription.id || '',
            });
          }
          // Mixpanel tracking for verification
          mixpanel.track('Google Conversion', {
            user_email: userStore.user?.email,
            subscription_id: subscription.id,
            plan: 'basic',
            value: 30.0,
            currency: 'USD',
            google_conversion_id: 'AW-16989360809/dsGWCOyNzLYaEKmllKU_'
          });
        }
      }
    }, [userStore.user?.subscriptions?.raw_subscriptions, isProUser]);

    return (
      <div className="add-article-container" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        margin: '0',
        marginLeft: window.innerWidth < 600 ? '0' : (window.innerWidth > 1200 ? '0' : '10px'),
        marginRight: window.innerWidth < 600 ? '0' : (window.innerWidth > 1200 ? '0' : '10px'),
        marginTop: '0',
        width: window.innerWidth > 1200 ? '100%' : 'auto',
      }}>

        <Modal
          isOpen={isModalOpen && !isLoading}
          onDismiss={hideModal}
          isBlocking={false}
          isDarkOverlay={true}
          containerClassName={contentStyles.container}
        >
          <div>
            {modalContent ? (
              <>
                {modalContent.customContent ? (
                  modalContent.customContent
                ) : (
                  <>
                    <div style={{ 
                      color: 'white', 
                      marginBottom: '16px', 
                      fontWeight: '600',
                      fontSize: '20px',
                      lineHeight: '1.4'
                    }}>
                      {modalContent.title}
                    </div>
                    <div style={{ 
                      color: 'rgba(255, 255, 255, 0.9)', 
                      marginBottom: '24px',
                      fontSize: '16px',
                      lineHeight: '1.5'
                    }}>
                      {modalContent.message}
                    </div>
                    <div style={{ 
                      display: 'flex', 
                      gap: '12px',
                      justifyContent: 'flex-end'
                    }}>
                      {modalContent.actionText && (
                        <button
                          onClick={modalContent.actionHandler}
                          className="clickable"
                          style={{
                            backgroundColor: '#1976d2',
                            border: 'none',
                            color: 'white',
                            borderRadius: '12px',
                            fontSize: '14px',
                            padding: '12px 20px',
                            outline: 'none',
                            cursor: 'pointer',
                            fontWeight: '600',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#1565c0';
                            e.currentTarget.style.transform = 'translateY(-1px)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#1976d2';
                            e.currentTarget.style.transform = 'translateY(0)';
                          }}
                        >
                          {modalContent.actionText}
                        </button>
                      )}
                      <button
                        onClick={hideModal}
                        className="clickable"
                        style={{
                          backgroundColor: 'transparent',
                          border: '1px solid rgba(255, 255, 255, 0.2)',
                          color: 'rgba(255, 255, 255, 0.8)',
                          borderRadius: '12px',
                          fontSize: '14px',
                          padding: '12px 20px',
                          outline: 'none',
                          cursor: 'pointer',
                          fontWeight: '500',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                          e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div style={{ color: 'white' }}>
                  {articleUrl && user && user.user_id && isSupportedType(articleUrl, user.user_id)}
                </div>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end',
                  marginTop: '20px'
                }}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      hideModal();
                    }}
                    className="clickable"
                    style={{
                      backgroundColor: 'transparent',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      color: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '12px',
                      fontSize: '14px',
                      padding: '12px 20px',
                      outline: 'none',
                      cursor: 'pointer',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                      e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                    }}
                  >
                    Close
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal>
        <Modal
          isOpen={showLinkModal && !isLoading}
          onDismiss={() => setShowLinkModal(false)}
          isBlocking={false}
          isDarkOverlay={true}
          containerClassName={contentStyles.container}
          onLayerDidMount={() => {
            // Focus after modal layer is mounted
            setTimeout(() => {
              if (linkInputRef.current) {
                linkInputRef.current.focus();
                console.log('Link input focused via onLayerDidMount');
              }
            }, 100);
          }}
        >
          <div>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              marginBottom: '20px' 
            }}>
              <div style={{ 
                color: 'white', 
                fontWeight: '600',
                fontSize: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <LinkIcon style={{ fontSize: '24px', color: '#1976d2' }} />
                Add Link
              </div>
              <Tooltip 
                title="Learn how to add articles" 
                placement="top"
              >
                <a 
                  href="https://help.audioread.com/en/articles/9854814-how-can-i-add-articles-to-audioread"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ 
                    color: '#757575',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px',
                    borderRadius: '50%',
                    transition: 'all 0.2s ease',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#1976d2';
                    e.currentTarget.style.backgroundColor = 'rgba(25, 118, 210, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = '#757575';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <HelpIcon fontSize="small" />
                </a>
              </Tooltip>
            </div>
            
            <form onSubmit={handleLinkModalSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <input
                  ref={linkInputRef}
                  type="url"
                  placeholder="Enter article URL"
                  value={linkInputValue}
                  onChange={(e) => setLinkInputValue(e.target.value)}
                  style={{ 
                    width: '100%',
                    height: '48px',
                    fontSize: '16px',
                    padding: '0 16px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    borderRadius: '12px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    color: 'white',
                    outline: 'none',
                    transition: 'all 0.2s ease',
                    boxSizing: 'border-box'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#1976d2';
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.08)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                  }}
                />
              </div>
              
              <div style={{ 
                display: 'flex', 
                gap: '12px',
                justifyContent: 'flex-end'
              }}>
                <button
                  type="button"
                  className="clickable"
                  onClick={() => {
                    setShowLinkModal(false);
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: 'rgba(255, 255, 255, 0.8)',
                    borderRadius: '12px',
                    fontSize: '14px',
                    padding: '12px 20px',
                    outline: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="clickable"
                  style={{
                    backgroundColor: '#1976d2',
                    border: 'none',
                    color: 'white',
                    borderRadius: '12px',
                    fontSize: '14px',
                    padding: '12px 20px',
                    outline: 'none',
                    cursor: 'pointer',
                    fontWeight: '600',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#1565c0';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#1976d2';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <LinkIcon style={{ fontSize: '18px' }} />
                  Add Link
                </button>
              </div>
            </form>
          </div>
        </Modal>
        
        {/* Feeds Modal */}
        <FeedsModal 
          isOpen={showFeedsModal}
          onClose={() => setShowFeedsModal(false)}
        />
        {/* Desktop Buttons */}
        <div
          style={{
            width: '100%',
            display: isMobile ? 'none' : 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '15px',
            marginBottom: '8px',
            flexWrap: 'nowrap',
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
          }}>
            <Link
              className="input-button"
              to="/add/text?type=input_text"
              style={{
                width: '120px',
                height: '45px',
                borderColor: '#dddddda1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                color: 'white',
                border: '1px solid #dddddda1',
                borderRadius: '9px',
                backgroundColor: 'transparent',
                fontSize: '14px',
                fontWeight: '500',
                gap: '8px',
              }}
            >
              <TextIcon style={{ fontSize: '20px' }} />
              Paste Text
            </Link>
            
            <div
              style={{
                width: '120px',
                height: '45px',
                position: 'relative',
              }}
            >
              <Upload />
            </div>

            <button
              onClick={handleLinkButtonClick}
              style={{
                width: '120px',
                height: '45px',
                borderColor: '#dddddda1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                border: '1px solid #dddddda1',
                borderRadius: '9px',
                backgroundColor: 'transparent',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                gap: '8px',
              }}
            >
              <LinkIcon style={{ fontSize: '20px' }} />
              Link
            </button>

            <BonusIndicator action={gamificationStore.actions.SUBSCRIBE_FEED}>
              <button
                onClick={handleRssButtonClick}
                style={{
                  width: '120px',
                  height: '45px',
                  borderColor: '#dddddda1',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  border: '1px solid #dddddda1',
                  borderRadius: '9px',
                  backgroundColor: 'transparent',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  gap: '8px',
                }}
              >
                <RssFeedIcon style={{ fontSize: '20px' }} />
                RSS Feeds
              </button>
            </BonusIndicator>

            <button
              onClick={handleEmailButtonClick}
              style={{
                width: '120px',
                height: '45px',
                borderColor: '#dddddda1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                border: '1px solid #dddddda1',
                borderRadius: '9px',
                backgroundColor: 'transparent',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                gap: '8px',
              }}
            >
              <EmailIcon style={{ fontSize: '20px' }} />
              Email
            </button>
          </div>

          {/* Playlist Search - Only show when more than 20 articles */}
          {store.playlistArticles && store.playlistArticles.length > 20 && (
            <div style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              maxWidth: '300px',
              width: '100%'
            }}>
              <SearchIcon style={{
                position: 'absolute',
                left: '12px',
                color: 'rgba(255, 255, 255, 0.5)',
                fontSize: '18px',
                zIndex: 1,
                pointerEvents: 'none'
              }} />
              <input
                type="text"
                placeholder="Search your playlist..."
                onChange={(e) => {
                  const value = e.target.value;
                  // Debounced search - update store search query
                  clearTimeout(window.playlistSearchTimeout);
                  window.playlistSearchTimeout = setTimeout(() => {
                    store.updatePlaylistSearch(value);
                  }, 300);
                }}
                style={{
                  width: '100%',
                  height: '45px',
                  padding: '0 40px 0 40px',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '9px',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  color: 'white',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  boxSizing: 'border-box',
                  fontFamily: 'Cabin, sans-serif'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.08)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#1976d2';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
              />
            </div>
          )}
        </div>

        {/* Mobile Add Article Button */}
        <div
          style={{
            display: isMobile ? 'block' : 'none',
            width: '100%',
            marginBottom: '8px',
            position: 'relative',
            overflow: 'visible',
          }}
        >
          <BonusIndicator action={gamificationStore.actions.ADD_ARTICLE}>
            <button
              onClick={handleMobileMenuToggle}
              style={{
                width: 'calc(100% - 48px)', // Reduced width to make room for bonus badge
                height: '56px',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: '28px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.25)',
                transition: 'all 0.2s ease-in-out',
                fontFamily: 'Cabin, sans-serif',
                margin: '0 24px', // Increased margin to center the button and make room for badge
                position: 'relative',
                zIndex: 1,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1565c0';
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.35)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#1976d2';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(25, 118, 210, 0.25)';
              }}
            >
              <Plus style={{ width: '16px', height: '16px' }} />
              Add Article
            </button>
          </BonusIndicator>

          {/* Mobile Playlist Search - Only show when more than 20 articles */}
          {store.playlistArticles && store.playlistArticles.length > 20 && (
            <div
              style={{
                width: 'calc(100% - 32px)',
                margin: '8px 16px 0 16px',
                position: 'relative',
              }}
            >
              <SearchIcon style={{
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'rgba(255, 255, 255, 0.5)',
                fontSize: '20px',
                zIndex: 1,
                pointerEvents: 'none'
              }} />
              <input
                type="text"
                placeholder="Search your playlist..."
                onChange={(e) => {
                  const value = e.target.value;
                  // Debounced search - update store search query
                  clearTimeout(window.playlistSearchTimeout);
                  window.playlistSearchTimeout = setTimeout(() => {
                    store.updatePlaylistSearch(value);
                  }, 300);
                }}
                style={{
                  width: '100%',
                  height: '56px',
                  padding: '0 20px 0 56px',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '28px',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  color: 'white',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  boxSizing: 'border-box',
                  fontFamily: 'Cabin, sans-serif',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.08)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#1976d2';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
              />
            </div>
          )}

          {/* Mobile Menu Dropdown */}
          <div
            style={{
              display: showMobileMenu ? 'block' : 'none',
              backgroundColor: 'rgba(25, 25, 35, 0.95)',
              borderRadius: '12px',
              marginTop: '8px',
              marginLeft: '16px',
              marginRight: '16px',
              padding: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)',
              animation: showMobileMenu ? 'slideDown 0.3s ease-out' : 'none',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link
                to="/add/text?type=input_text"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 16px',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  transition: 'background-color 0.2s ease',
                  gap: '12px',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
              >
                <TextIcon style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Paste Text</span>
              </Link>

              <button
                onClick={() => {
                  // Create a hidden file input and trigger it
                  const fileInput = document.createElement('input');
                  fileInput.type = 'file';
                  fileInput.accept = '.pdf';
                  fileInput.style.display = 'none';
                  
                  fileInput.onchange = (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      // Handle the file upload similar to the Upload component
                      setShowMobileMenu(false);
                      
                      // Create FormData and upload
                      const formData = new FormData();
                      formData.append('file', file);
                      
                      // Show loading state
                      setIsLoading(true);
                      
                      axios
                        .get(process.env.REACT_APP_BACKEND_URL + '/api/upload')
                        .then((res) => {
                          const preSignedUrl = res.data;

                          axios
                            .put(preSignedUrl, file, {
                              onUploadProgress: (progressEvent) => {
                                const progressPercentage = Math.round(
                                  (progressEvent.loaded * 100) / progressEvent.total
                                );
                                console.log('Upload progress:', progressPercentage + '%');
                              },
                              headers: {
                                Accept: '*/*',
                                'Content-Type': 'application/pdf',
                              },
                            })
                            .then((res) => {
                              // POST to /api/upload
                              axios
                                .post(process.env.REACT_APP_BACKEND_URL + '/api/upload', {
                                  article_url: preSignedUrl.split('?')[0],
                                })
                                .then((res) => {
                                  setIsLoading(false);
                                  // Redirect to text page with the parsed content
                                  window.location.href = `/add/text?type=pdf&title=${encodeURIComponent(
                                    file.name
                                  )}&text=${encodeURIComponent(
                                    res.data.A
                                  )}&backupText=${encodeURIComponent(res.data.B)}`;
                                })
                                .catch((err) => {
                                  setIsLoading(false);
                                  console.error('Error parsing file:', err);
                                  setModalContent({
                                    title: "Upload Error",
                                    message: "There was an error processing your file. Please try again.",
                                  });
                                  showModal();
                                });
                            })
                            .catch((err) => {
                              setIsLoading(false);
                              console.error('Error uploading file:', err);
                              setModalContent({
                                title: "Upload Error",
                                message: "There was an error uploading your file. Please try again.",
                              });
                              showModal();
                            });
                        })
                        .catch((err) => {
                          setIsLoading(false);
                          console.error('Error getting upload URL:', err);
                          setModalContent({
                            title: "Upload Error",
                            message: "There was an error preparing the upload. Please try again.",
                          });
                          showModal();
                        });
                    }
                  };
                  
                  document.body.appendChild(fileInput);
                  fileInput.click();
                  document.body.removeChild(fileInput);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 16px',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  transition: 'background-color 0.2s ease',
                  gap: '12px',
                  cursor: 'pointer',
                  width: '100%',
                  textAlign: 'left',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
              >
                <UploadIcon style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Upload File</span>
              </button>

              <button
                onClick={() => {
                  handleLinkButtonClick();
                  setShowMobileMenu(false);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 16px',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  transition: 'background-color 0.2s ease',
                  gap: '12px',
                  cursor: 'pointer',
                  width: '100%',
                  textAlign: 'left',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
              >
                <LinkIcon style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Link</span>
              </button>

              <BonusIndicator action={gamificationStore.actions.SUBSCRIBE_FEED}>
                <button
                  onClick={() => {
                    handleRssButtonClick();
                    setShowMobileMenu(false);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 16px',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    transition: 'background-color 0.2s ease',
                    gap: '12px',
                    cursor: 'pointer',
                    width: '100%',
                    textAlign: 'left',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                  }}
                >
                  <RssFeedIcon style={{ fontSize: '20px' }} />
                  <span style={{ fontSize: '14px', fontWeight: '500' }}>RSS Feeds</span>
                </button>
              </BonusIndicator>

              <button
                onClick={() => {
                  handleEmailButtonClick();
                  setShowMobileMenu(false);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '12px 16px',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  transition: 'background-color 0.2s ease',
                  gap: '12px',
                  cursor: 'pointer',
                  width: '100%',
                  textAlign: 'left',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                }}
              >
                <EmailIcon style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Email</span>
              </button>
            </div>
          </div>
        </div>
        {/* Hidden form for extensions and shortcuts - maintains original functionality */}
        <form 
          onSubmit={handleSubmit}
          style={{
            position: 'absolute',
            left: '-9999px',
            top: '-9999px',
            opacity: 0,
            pointerEvents: 'none',
            zIndex: -1
          }}
        >
          <input
            type="text"
            placeholder="Enter URL"
            value={articleUrl}
            onChange={handleInputChange}
            style={{
              width: '300px',
              height: '45px',
              border: '1px solid #dddddda1',
              borderRadius: '9px',
              padding: '0 15px',
              fontSize: '16px',
              backgroundColor: 'transparent',
              color: 'white'
            }}
          />
          <BonusIndicator action={gamificationStore.actions.ADD_ARTICLE}>
            <button
              type="submit"
              disabled={isLoading}
              style={{
                width: '120px',
                height: '45px',
                backgroundColor: '#1976d2',
                color: 'white',
                border: 'none',
                borderRadius: '9px',
                fontSize: '16px',
                cursor: 'pointer',
                marginLeft: '10px'
              }}
            >
              {isLoading ? (
                <img src={loadingIcon} style={{ height: '25px' }} alt="loading..." />
              ) : (
                buttonMessage
              )}
            </button>
          </BonusIndicator>
        </form>

        <div className="status">{status}</div>

        {/* <Checkout /> */}
        {app && app === 'chrome' && (
          <>
            <div style={{ marginTop: '15px', opacity: '0.8' }}>
              Change shorcuts at chrome://extensions/shortcuts
            </div>
          </>
        )}
        <div style={{ display: 'none' }}>
          <h3>How To...</h3>
          <div>Send content from a mobile device</div>
          <div>Listen in a podcast app</div>
          <div>Change the shortcuts</div>
          <div>Send private/paywalled content</div>
          <div>Convert emails</div>
        </div>

        <div
          className="add-article-app-links"
          style={{ paddingBottom: '20px' }}
        >
          <a href="https://audioread.tolt.io/" target="_blank" style={{
            cursor: 'pointer',
          }}>
            <span></span>
          </a>
{/* 
          <Tooltip 
            title="Treat this URL as an RSS feed"
            placement="top"
          >
            <div 
              className="small-transparent-button" 
              style={{ 
                width: '257px', 
                marginBottom: '10px',
                transition: 'transform 0.2s ease-in-out',
                cursor: 'pointer',
                position: 'relative'
              }}
              onClick={() => setForceFeed(!forceFeed)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div className="content" style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                <Switch
                  checked={forceFeed}
                  onClick={(e) => {
                    e.stopPropagation();
                    setForceFeed(!forceFeed);
                  }}
                  color="primary"
                  name="forceFeed"
                  inputProps={{ 'aria-label': 'Force Feed' }}
                  sx={{
                    marginRight: '10px',
                    '& .MuiSwitch-switchBase': {
                      '&.Mui-checked': {
                        color: '#fff',
                        '& + .MuiSwitch-track': {
                          backgroundColor: '#1976d2',
                        },
                      },
                    },
                    '& .MuiSwitch-track': {
                      backgroundColor: '#757575',
                    },
                  }}
                />
                <label style={{ fontWeight: 'bold', marginLeft: '-10px' }}>Treat as Feed</label>
                <Tooltip title="Learn how feeds work" placement="top">
                  <a 
                    href="https://help.audioread.com/en/articles/11060313-how-to-use-feeds-on-audioread"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    style={{ 
                      marginLeft: '8px',
                      color: '#757575',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <HelpIcon fontSize="small" />
                  </a>
                </Tooltip>
              </div>
            </div>
          </Tooltip> */}

          {/* <div id="audioread-hotjar-feedback"></div> */}
        </div>

        {/* Playlist Articles Section */}
        <div style={{ 
          marginTop: '-30px',
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
          padding: '0 0 75px 0'
        }}>
          {/* Playlist Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '16px',
            padding: '0 4px',
            animation: 'fadeInUp 0.6s ease-out'
          }}>
            <div style={{
              height: '1px',
              flex: 1,
              background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
              animation: 'expandWidth 0.8s ease-out'
            }} />
            <span style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '14px',
              fontWeight: '500',
              margin: '0 12px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              animation: 'fadeIn 0.6s ease-out 0.2s both'
            }}>
              Your Playlist
            </span>
            <div style={{
              height: '1px',
              flex: 1,
              background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
              animation: 'expandWidth 0.8s ease-out'
            }} />
          </div>
          
          <PlaylistArticles 
            articles={store.playlistArticles}
            trackingId={trackingId}
            addArticleToPlaylist={store.addArticleToPlaylist}
            selectArticle={store.changeCurrentArticle}
            togglePlayed={store.togglePlayed}
            removeArticle={store.removeArticle}
            changeMode={store.changePlaylistMode}
          />
        </div>

      </div>
    );
  }
);

export default AddArticle;
